export default __webpack_public_path__ + "static/media/poster2.793de7eb.png";